import { AxiosInstance } from "axios";

const FEATURE_LABELS: Record<string, string> = {
  FACTURACION: "Facturación electrónica",
  NOTA_CREDITO: "Notas de crédito",
  NOTA_DEBITO: "Notas de débito",
  COTIZACION: "Cotizaciones",
  INVENTARIO: "Inventario",
  POS: "Punto de venta",
  COMPRAS: "Compras / proveedores",
  RETENCIONES: "Retenciones",
  GUIA_REMISION: "Guías de remisión",
  GASTOS: "Gastos",
  MULTI_BODEGA: "Multi-bodega",
  CUENTAS_COBRAR_PAGAR: "Cuentas por cobrar / pagar",
  BANCOS_CAJA: "Bancos y caja",
  RECURRENCIAS: "Recurrencias",
  IMPORTACION_MASIVA: "Importación masiva",
  DASHBOARD_AVANZADO: "Dashboard avanzado",
  REPORTES_PROGRAMADOS: "Reportes programados",
  API_KEYS: "API keys",
  WEBHOOKS_SRI: "Webhooks SRI",
  BACKUPS: "Backups",
  MULTI_EMPRESA: "Multi-empresa",
};

const RESOURCE_LABELS: Record<string, string> = {
  USER: "usuarios",
  BRANCH: "sucursales",
  PRODUCT: "productos",
  STORAGE: "almacenamiento",
};

// Reescribe los errores de plan a un texto legible antes de que el `catch` de
// cada pantalla lo muestre en un toast.
const rewritePlanError = (error: any) => {
  const raw: string = error?.response?.data?.message ?? "";

  if (raw.startsWith("PLAN_FEATURE_NOT_INCLUDED")) {
    const code = raw.split(":")[1]?.trim() ?? "";
    const label = FEATURE_LABELS[code] ?? code;
    const nice = `Tu plan no incluye el módulo "${label}". Contáctanos para ampliarlo.`;
    if (error.response?.data) error.response.data.message = nice;
    if (error.message) error.message = nice;
  } else if (raw.startsWith("PLAN_LIMIT_REACHED")) {
    const res = raw.split(":")[1]?.trim() ?? "";
    const label = RESOURCE_LABELS[res] ?? "recursos";
    const nice = `Llegaste al límite de ${label} de tu plan. Actualiza tu plan o solicita un add-on.`;
    if (error.response?.data) error.response.data.message = nice;
    if (error.message) error.message = nice;
  } else if (raw === "PLAN_DOCUMENT_LIMIT_REACHED") {
    const nice =
      "Llegaste al límite de comprobantes electrónicos de tu plan en este período. Solicita un paquete adicional.";
    if (error.response?.data) error.response.data.message = nice;
    if (error.message) error.message = nice;
  }
};

const handle402 = (error: any) => {
  const status = error.response?.status;
  const message: string = error.response?.data?.message ?? "";

  if (status === 402) {
    if (message.startsWith("SUBSCRIPTION_BLOCKED")) {
      const code = message.replace("SUBSCRIPTION_BLOCKED:", "").trim();
      sessionStorage.setItem("subscription_blocked_code", code);
      window.location.href = "/subscription-blocked";
      throw new Error("SUBSCRIPTION_BLOCKED");
    }
    // 402 de límite de comprobantes u otro: no redirige, solo mensaje legible.
    rewritePlanError(error);
    return Promise.reject(error);
  }

  if (status === 403 || status === 400 || status === 409) {
    rewritePlanError(error);
  }

  return Promise.reject(error);
};

export const addSubscriptionInterceptor = (instance: AxiosInstance) => {
  // Idempotente: evita registrar el interceptor dos veces sobre la misma
  // instancia (p. ej. si aparece repetida en la lista de setupAllInterceptors).
  const tagged = instance as AxiosInstance & { __subInterceptor?: boolean };
  if (tagged.__subInterceptor) return;
  tagged.__subInterceptor = true;

  instance.interceptors.response.use(
    (response) => response,
    (error) => handle402(error),
  );
};
